import React from 'react';

const AcurisProprietaryIcon = ({
  svgClassName,
  pathClassName,
  iconContainerClassName
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: iconContainerClassName
  }, /*#__PURE__*/React.createElement("span", {
    className: "visuallyhidden"
  }, "Acuris Proprietary"), /*#__PURE__*/React.createElement("svg", {
    className: svgClassName,
    width: "13px",
    height: "12px",
    viewBox: "0 0 13 12",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React.createElement("desc", null, "Proprietary Icon"), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-246.000000, -1152.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.000000, 1145.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(230.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: pathClassName,
    d: "M9.82857143,8.85257143 L6.74285714,7.16 C6.61402763,7.08924632 6.45797237,7.08924632 6.32914286,7.16 L3.24342857,8.85257143 L1.76914286,11.2182857 L6.53485714,8.46628571 L11.3005714,11.2182857 L9.82857143,8.85257143 Z",
    fill: "#8E334D"
  }), /*#__PURE__*/React.createElement("path", {
    className: pathClassName,
    d: "M6.01371429,0.342857143 L0.114285714,11.4411429 C0.046115609,11.5794169 0.0765324068,11.7460196 0.189165573,11.8512843 C0.301798739,11.9565489 0.470075684,11.9756413 0.603428571,11.8982857 L1.768,11.2125714 L6.53371429,3.56342857 L11.2994286,11.2125714 L12.464,11.8982857 C12.5973529,11.9756413 12.7656298,11.9565489 12.878263,11.8512843 C12.9908962,11.7460196 13.021313,11.5794169 12.9531429,11.4411429 L7.05257143,0.342857143 C6.95031501,0.150958064 6.75058626,0.0310713456 6.53314286,0.0310713456 C6.31569946,0.0310713456 6.11597071,0.150958064 6.01371429,0.342857143 Z",
    fill: "#D84A57"
  })))))));
};

export default AcurisProprietaryIcon;
//# sourceMappingURL=index.js.map
